import { computed, Injectable, Signal, signal } from '@angular/core';
import { AuthFacade, AuthorizationConcept, AuthorizationService, AuthorizationType } from '@iot-platform/auth';
import { BaseFacade, Contact, Filter, Pagination } from '@iot-platform/models/common';
import { Store } from '@ngrx/store';
import { noop } from 'rxjs';
import { ContactsActions } from '../actions';
import { ContactsSelectors } from '../selectors/contacts.selectors';

/* eslint-disable @angular-eslint/prefer-inject */
@Injectable({
  providedIn: 'root'
})
export class ContactsFacade extends BaseFacade<Contact, Pagination, Filter> {
  maxContacts: Signal<number> = signal(20);

  canCreate = computed(() => {
    this.authFacade.privileges();
    return this.authorizationService.applyAuthorization(AuthorizationConcept.CONTACT, AuthorizationType.CREATE);
  });
  canRead = computed(() => {
    this.authFacade.privileges();
    return this.authorizationService.applyAuthorization(AuthorizationConcept.CONTACT, AuthorizationType.READ);
  });
  canUpdate = computed(() => {
    this.authFacade.privileges();
    return this.authorizationService.applyAuthorization(AuthorizationConcept.CONTACT, AuthorizationType.UPDATE);
  });
  canDelete = computed(() => {
    this.authFacade.privileges();
    return this.authorizationService.applyAuthorization(AuthorizationConcept.CONTACT, AuthorizationType.DELETE);
  });

  constructor(
    protected override store: Store,
    protected override selector: ContactsSelectors,
    protected readonly authFacade: AuthFacade,
    protected readonly authorizationService: AuthorizationService
  ) {
    super(store, selector);
  }

  loadContacts(siteId: string): void {
    this.store.dispatch(ContactsActions.loadContacts({ siteId }));
  }

  addContact(contact: Contact): void {
    this.store.dispatch(ContactsActions.addContact({ contact }));
  }

  updateContact(contact: Contact): void {
    this.store.dispatch(ContactsActions.updateContact({ contact }));
  }

  deleteContact(contact: Contact): void {
    this.store.dispatch(ContactsActions.deleteContact({ contact }));
  }

  getAll(): void {
    noop();
  }

  setFilters(): void {
    noop();
  }
}
